import { Typography } from "antd";
import { BasicFormBuilder, LoadingOverlay, ProhibitedArea } from "components";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AppState from "store/AppState";
import { getDataObjectPermissionRequest } from "store/dataObjects/actions";

export default function DataSetRecordForm({
    isLoading,
    loadingMessage = "Getting dataset record...",
    isProhibited,
    dataObject,
    schemaModel,
    onCancel,
    onSave,
}: IDataSetRecordFormProps) {
    const [canEdit, setCanEdit] = useState(false);
    const dispatch = useDispatch();
    const dataObjectPermission = useSelector((state: AppState) => state.dataObjects.dataObjectPermission);

    useEffect(() => {
        if (dataObjectPermission?.canEdit) {
            setCanEdit(true);
        } else {
            setCanEdit(false);
        }
    }, [dataObjectPermission]);

    useEffect(() => {
        dispatch(getDataObjectPermissionRequest());
    }, [dispatch]);

    return isLoading ? (
        <LoadingOverlay busy={true} message={loadingMessage} />
    ) : isProhibited ? (
        <ProhibitedArea />
    ) : dataObject ? (
        <BasicFormBuilder
            key={dataObject.dataObjectId}
            formDataObject={dataObject}
            schemaFields={schemaModel ? schemaModel.fields : []}
            readOnly={!canEdit}
            showRevealButton={true}
            onCancel={onCancel}
            onUpdate={onSave}
        ></BasicFormBuilder>
    ) : (
        <Typography.Text>No data</Typography.Text>
    );
}
